import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

export default class SearchBar extends Component {
  render () {
    const { value, onChange, placeholder, additionalStyling } = this.props

    return h.div({ ...h.ca(styles.wrapper), ...additionalStyling },
      h.input({
        ...h.ca(styles.bar),
        placeholder: placeholder || 'Search...',
        value,
        onChange: e => onChange(e.target.value),
        name: 'Search Bar'
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SearchBar/index.js